import React, { useContext, useEffect } from "react";

import getBuyerAPIDomain from "../getBuyerAPIDomain";
import { UpdateSavedSearchProps } from "../SavedSearches/types";
import updateSavedSearches from "../SavedSearches/api/updateSavedSearches";
import { ErrorContext } from "../context/ErrorContext";

export const useUpdateSavedSearches = (
  params: UpdateSavedSearchProps,
  shouldUpdate: boolean,
  setShouldUpdate: React.Dispatch<React.SetStateAction<boolean>>,
  setShowConfirmationPage?: React.Dispatch<React.SetStateAction<boolean>>,
  isToUseAuthZero?: boolean,
  accessToken?: string
) => {
  const errorContext = useContext(ErrorContext);
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  const updateSavedSearchResultsUrl = buyerAPIDomain
    ? new URL(`${buyerAPIDomain.href}/savedsearch`, buyerAPIDomain).href
    : "";

  useEffect(() => {
    if (shouldUpdate) {
      updateSavedSearches(
        updateSavedSearchResultsUrl,
        {
          id: params.id,
          url: params.url,
          searchName: params.searchName,
          deactivationDate: params.deactivationDate,
          deleteOnDeactivation: params.deleteOnDeactivation,
          notifyMe: params.notifyMe,
        },
        accessToken,
        isToUseAuthZero
      )
        .then((success) => {
          if (success) {
            setShowConfirmationPage(true);
            setShouldUpdate(false);
          }
        })
        .catch((error) => {
          errorContext?.dispatch({ type: "stock-alerts" });
          setShouldUpdate(false);
        });
    }
  }, [shouldUpdate]);
};
